import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ValueOrUnknownCellRenderer: React.FC<ICellRendererParams> = ({ value }) => {
  const { t } = useTranslation();
  const label = value && value !== '' ? value : t('companies:unknown');

  return <>{label}</>;
};

export default ValueOrUnknownCellRenderer;
